import { useState, useMemo } from "react";
import HotelCard from "./HotelCard";
import Pagination from "common/pagination/Pagination";
import hotelesData from "assets/HotelesNacionales.json";
import { ReactComponent as BgLines } from "assets/patterns/Textura.svg";
import "./Hotels.css";
import Tabs from "components/tabs/Tabs";

export default function HotelsSection() {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("all");

  const hotelsPerPage = 6;

  const tabs = [
    { label: "Nuestros destinos", value: "all" },
    // { label: "Redime noches", value: true },
    // { label: "Convenios", value: false },
  ];

  // 🔍 Filtrado por tab
  const filteredHotels = useMemo(() => {
    if (activeTab === "all") return hotelesData.HotelesNacionales;
    return hotelesData.HotelesNacionales.filter(
      (hotel) => hotel.noches === activeTab
    );
  }, [activeTab]);

  const totalPages = Math.ceil(filteredHotels.length / hotelsPerPage);

  const currentHotels = filteredHotels.slice(
    (currentPage - 1) * hotelsPerPage,
    currentPage * hotelsPerPage
  );

  // Reset page cuando cambia la tab
  const handleTabChange = (value) => {
    setActiveTab(value);
    setCurrentPage(1);
  };

  return (
    <section className="hotels-section">
      <BgLines className="bg-icon" />

      <article className="container-section-hotels">
        <div className="section-header">
          <span className="section-badge">ALOJAMIENTOS EXCLUSIVOS</span>

          <h2 className="section-title">
            Hoteles de <span className="title-highlight">Ensueño</span>
          </h2>

          <p className="section-description">
            Seleccionamos los mejores alojamientos del mundo para que tu
            experiencia sea inolvidable
          </p>
        </div>

        {/* 🧭 Tabs */}
        <Tabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} />

        <div className="hotels-grid">
          {currentHotels.map((hotel, index) => (
            <HotelCard
              key={`${activeTab}-${currentPage}-${index}`}
              hotel={hotel}
              index={index}
            />
          ))}
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </article>
    </section>
  );
}
